
import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';

import { Modal, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { BsCircleFill } from 'react-icons/bs';
import { IoIosAddCircle } from "react-icons/io";
import { IoChevronBackCircle, IoPeople } from "react-icons/io5";
import Moment from 'react-moment';
import 'moment-timezone';


import AuthContext from 'store/AuthContext';
import personsServicse from '../../services/persons.servicse';
import flightsServicse from '../../services/flights.servicse';
import PersonsService from '../../services/persons.servicse';
import ErrPersonsService from '../../services/errPerson.service';
import PersonNewEditModal from './PersonNewEditModal';
import AppButton from 'components/FormsUI/AppButton/appButton';
import AppPagination from "components/common/AppPagination";
import AppSkeleton from 'components/common/skeleton/AppSkeleton';
import { AppTableNoData } from 'components/common/AppTableUtils';
import ToastContext from 'store/ToastContext';

import '../../App.css';
import '../common/tables.css';
import ErrorsForPerson from './ErrorsForPerson';

export default function PersonList(props) {
    const { userInfo } = useContext(AuthContext);
    const { openToast } = useContext(ToastContext);
    const [data, setData] = useState([]);
    const [spinnerLoading, setSpinnerLoading] = useState(true);
    const [flight, setFlight] = useState(null);
    const [selectedItem, setSelectedItem] = useState({});
    const [message, setMessage] = useState("");
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showModalForUpdateInsert, setShowModalForUpdateInsert] = useState(false);
   // const [showErrorsForPersonModal, setShowErrorsForPersonModal] = useState(false);
    const [selectedPerson, setSelectedPerson] = useState(null);
    const [action, setAction] = useState();
   // const [activeId, setActiveId] = useState();
    const [paginationObject, setPaginationObject] = useState({ currPage: 1, pageSize: 10, startIndex: 0, endIndex: 10 });
    const { flightId, personType} = useParams()
    const [errorsData,setErrorsData]= useState([]);
    const [showModalErrors,setShowModalErrors]=useState(false);

    const fetchData = async () => {

        var getFlightDetails = await flightsServicse.getCurrentFlight(flightId);
       
        setFlight(getFlightDetails);
   

        PersonsService.getPersons(flightId, personType)
            .then((personRes) => {
                if (personRes) {
                    setData(personRes);
                }
                setSpinnerLoading(false);
            }).catch((error) => {
                setData([]);
                setSpinnerLoading(false);
            });
    }

    useEffect(() => {
        setSpinnerLoading(true);
        fetchData();
    }, [personType])

    const handleErrors = (person) => {   
        if (person.flightErrors!==null){    
        setErrorsData(person.flightErrors);
        setSelectedPerson(person);
        setShowModalErrors(true);}
    }

    const backhandler = () => {
        props.history.goBack();
    }

    const onRowUpdateSubmitted = async (values, action) => {
        setSpinnerLoading(true);
        setShowModalForUpdateInsert(false);
        PersonsService.getPersons(flightId, personType)
            .then((personRes) => {
                if (personRes) {
                    setData(personRes);
                }
                setSpinnerLoading(false);
            }).catch((error) => {
               // console.log(error);
                setData([]);
                setSpinnerLoading(false);
            });
    }

    const redirectToNewPerson = (flight, updateAction) => {
        setSelectedPerson({});
        setAction(updateAction);
        if (updateAction === "New") {
           // setActiveId(null);
        }
        setFlight(flight);
        setShowModalForUpdateInsert(true);
    }

    const redirectToUpdatePersons = async (person, updateAction, index) => {
        setAction(updateAction);
     //   setActiveId(index);
        setSelectedPerson(person);
        setShowModalForUpdateInsert(true);
    }

    const handleShow = (item, personType, index) => {
        var member=personType=== 'Crew' ?"member":"";
        setMessage('Are you sure you want to delete the ' + personType + ' '+member + '?');
        setSelectedItem(item);
       // setActiveId(index);
        setShowDeleteModal(true);
    }
    const HandleDelete = async () => {
        setSpinnerLoading(true);
        const del = await personsServicse.deletePerson(selectedItem);
        var member=personType=== 'Crew' ?"Crew member":"Passenger";
        if (del === 0) {
            PersonsService.getPersons(flightId, personType)
                .then((personRes) => {
                    if (personRes) {
                        setData(personRes);
                    }
                    setSpinnerLoading(false);
                }).catch((error) => {
                   // console.log(error);
                    setData([]);
                    setSpinnerLoading(false);
                });
                openToast(member+" was removed", "success");
        } else {
            openToast("There was an error in removing "+member, "error");
            setSpinnerLoading(false);
        }
        setShowDeleteModal(false);
    }

    const handleClose = () => {
        setShowDeleteModal(false);
       // setShowErrorsForPersonModal(false);
        setShowModalErrors(false);
    }

    const handleCloseUpdateInsert = () => {
        setShowModalForUpdateInsert(false);
    }

    //const redirectToErrorsForPerson = async (person,index) => {
      //  setSpinnerLoading(true);
       // setActiveId(index);
      //  setShowErrorsForPersonModal(true);
       // setSelectedPerson(person);
   // }
    const redirectToCrewOrPassErroneous = async(flightId, personType) => {
        setSpinnerLoading(true);
        var hasErrorsInList = await ErrPersonsService.getErrPersons(flightId, personType,null);
        if (hasErrorsInList.length === 0) {            
            openToast(`There are no erroneous ${personType} for this flight`, "warning");
            setSpinnerLoading(false);
        }
        else {
            props.history.push({                
                pathname: `/ErroneousPassengersCrew/${flight.id}/${personType === 'Crew' ? 'Crew' : 'Passenger'}`
            })
        }
        }
    const redirectToCrewOrPass = () => {
        props.history.push({
            pathname: `/personList/${flight.id}/${personType === 'Crew' ? 'Passenger' : 'Crew'}`
        })
    }

    const minValueDate = "0001-01-01T00:00:00Z";

    const handleCloseUpdateInsertPerson = () => { }
    const handleCloseErrorsForPerson = () => { }
    return (
        <div>
            <div className="marginBottom">
                <div className="row">
                    <div className="col-md-8"><h2>{personType} Data for Flight {flightId ? flight?.flightCode : null} on
                        &nbsp;<Moment format="DD MMM yy">{flight?.flightDateTime}</Moment></h2></div>
                    <div className="col-md-4 row px-0">
                        <div className='col-md'></div>
                        <div className='col-auto px-0 margingRight'>
                            <AppButton id="goToCrewOrPassErroneousBtn" isBlock={true} isLoading={spinnerLoading} action={() => redirectToCrewOrPassErroneous(flightId, personType)} icon={<IoPeople />} label={personType === "Crew" ? " Erroneous Crew" : "Erroneous Passengers"} ></AppButton>
                        </div>
                        <div className='col-auto px-0 margingRight'>
                            <AppButton id="goToCrewOrPassBtn" action={() => redirectToCrewOrPass()} icon={<IoPeople />} label={personType === "Crew" ? "Passengers" : "Crew"} ></AppButton>
                        </div>
                        {!userInfo.isOwner && (!(flight?.clobReceived === true && personType === "Crew") &&
                            (<div className='col-auto px-0 margingRight'>
                                <AppButton id="addNewPersonBtn" action={() => redirectToNewPerson(flight, "New")} icon={<IoIosAddCircle />} label={personType === "Crew" ? "Add Crew Member" : "Add Passenger"} ></AppButton>
                             </div>))
                        }                        
                    </div>
                </div>
            </div>
            <div>
                {spinnerLoading ? <AppSkeleton rows={paginationObject.pageSize} cols={12} variant="table" size="28px"/> : (
                    <React.Fragment>
                        <table className="table table-hover table-sm table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col"></th>
                                    {personType === "Passenger" && <th scope="col">PNR </th>}
                                    {personType === "Passenger" && <th scope="col">Unique Id</th>}
                                    <th scope="col">Embarking Airport</th>
                                    <th scope="col">Final airport</th>
                                    <th scope="col">Seat Number</th>
                                    <th scope="col">Last name</th>
                                    <th scope="col">First name</th>
                                    <th scope="col">Gender</th>
                                    <th scope="col">Birthdate</th>
                                    <th scope="col">Travel document type</th>
                                    <th scope="col">Travel document</th>
                                    <th scope="col">Expiry Date</th>
                                    <th scope="col">Issuing country</th>
                                    <th scope="col">Nationality</th>
                                    <th scope="col">Personal ID</th>
                                    <th scope="col">Stage</th>
                                    {!userInfo.isOwner && <th scope="col">Actions</th> }
                                </tr>
                            </thead>
                            <tbody>
                                  {data.slice(paginationObject.startIndex, paginationObject.endIndex).map((item, i) => {
                                    return (
                                        <tr  key={i}>
                                         <td className="col" style={{ textAlign: 'center' }} >
                                         <BsCircleFill className={(item.status === 1 || item.status === 4)  ? ("error") : 
                                            (item.status === 2) ? ("warning") :("success")} />
                                        </td>                                           
                                            {personType === "Passenger" && (<>
                                                <td className="col" >{item.pnr}</td> 
                                                <td className="col">{item.uniqueId}</td>
                                            </>)}
                                            <td className="col" >{item.embarkingAirport}</td>
                                            <td className="col" >{item.finalAirport}</td>
                                            <td className="col" >{item.seatNumber}</td>
                                            <td className="col" >{item.lastName?.toUpperCase()}</td>
                                            <td className="col" >{item.firstName?.toUpperCase()}</td>
                                            <td className="col" >{item.gender === "F" ? "Female" :
                                                item.gender === "M" ? "Male" : item.gender}</td>
                                            <td className="col" >
                                                <Moment format="DD MMM yy">{item.birthDate}</Moment>
                                            </td>
                                            <td className="col">{item.docTypeMrz}</td>
                                            <td className="col">{item.travelDocumentNumber}</td>
                                            <td className="col">
                                            {item.expiryDate!==minValueDate && item.expiryDate!==null ?
                                                <Moment format="DD MMM yy">{item.expiryDate}</Moment>:
                                                ""}
                                                </td>
                                            <td className="col">{item.issuingCountry}</td>
    
                                            <td className="col" >{item.nationalityCountry}</td>
                                            <td className="col">{item.personalId}</td>
                                            <td className="col">
                                                {item.stage === 1 ? "check-in" :
                                                    item.stage === 2 ? "on-board" :
                                                        item.stage === 3 ? "not-on-board" :
                                                            item.stage === 4 ? "cancelled" : null}
                                            </td>
                                            {!userInfo.isOwner && <td className="col">
                                                <Navbar.Collapse id="basic-navbar-nav">
                                                    <Nav className="me-auto">
                                                        <NavDropdown className="m-auto" title="..." id="basic-nav-dropdown">
                                                            {(<NavDropdown.Item onClick={() => { redirectToUpdatePersons(item, "Update", i) }} >Update {personType}</NavDropdown.Item>)}
                                                            <NavDropdown.Item onClick={() => handleShow(item, personType, i)}>Delete {personType}</NavDropdown.Item>                                                        
                                                        {item?.errorInd === 1 && item?.flightErrors && (<NavDropdown.Item onClick={() => handleErrors(item)}>Show Errors</NavDropdown.Item>)}                                                        
                                                        </NavDropdown>
                                                    </Nav>
                                                </Navbar.Collapse>
                                            </td>}
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                        {!data.length ? <AppTableNoData /> :
                            <AppPagination
                                pageSize={paginationObject.pageSize}
                                totalRecords={data.length}
                                currentPage={paginationObject.currPage}
                                endIndex={paginationObject.endIndex}
                                startIndex={paginationObject.startIndex}
                                setPaginationObject={(ele) => {
                                    setPaginationObject((data) => {
                                        return ({ ...data, pageSize: ele.pageSize, startIndex: ele.startIndex, endIndex: ele.endIndex, currPage: ele.currPage })
                                    })
                                }}
                            ></AppPagination>
                        }
                    </React.Fragment>
                )}
            </div>
            <div>
                <AppButton action={backhandler} label="Back" icon={<IoChevronBackCircle />}></AppButton>
            </div>

            <div>
                <Modal show={showDeleteModal} onHide={handleCloseUpdateInsertPerson}>
                    <Modal.Header>
                        <Modal.Title>Delete {personType} {personType === "Crew" ? <span> member</span> : null}</Modal.Title>
                        <span style={{ cursor: "pointer" }} onClick={handleClose}>X</span>
                    </Modal.Header>
                    <Modal.Body>{message}</Modal.Body>
                    <Modal.Footer>
                    <div className="col-2">
                        <AppButton action={HandleDelete} label="Yes" isLoading={spinnerLoading} isBlock={true}></AppButton>
                    </div>
                    <div className="col-2">
                        <AppButton action={handleClose} label="No" disabled={spinnerLoading} color="secondary" isBlock={true}></AppButton>
                    </div>
                    </Modal.Footer>
                </Modal>
            </div>
            <div>
                <Modal show={showModalForUpdateInsert} onHide={handleCloseUpdateInsertPerson}>
                    <Modal.Header >
                        <Modal.Title>{action} {personType} {personType === "Crew" ? <span> member</span> : null}</Modal.Title>                       
                        <span style={{ cursor: "pointer" }} onClick={handleCloseUpdateInsert}>X</span>
                    </Modal.Header>
                    <Modal.Body>
                        <PersonNewEditModal person={selectedPerson} flight={flight} action={action} personType={personType} onSubmitted={onRowUpdateSubmitted} />
                    </Modal.Body>
                </Modal>
            </div>
            <div>
                <Modal show={showModalErrors} onHide={handleCloseErrorsForPerson} backdrop="static" keyboard={false}>
                    <Modal.Header >
                        <Modal.Title>Errors for {personType} {personType === "Crew" ? <span> member</span> : null}</Modal.Title>                       
                        <span style={{ cursor: "pointer" }} onClick={handleClose}>X</span>
                    </Modal.Header>
                    <Modal.Body>
                        <ErrorsForPerson data={errorsData}  person={selectedPerson} personType={personType} />
                    </Modal.Body>
                </Modal>                            
            </div>
            </div>
    )
}